import React, { Component, Children } from 'react';
import { Grid, Button, Input, Icon, Divider } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { TRANSLATION_FILES } from './../constants/translation';

class SearchFilter extends Component {
  static propTypes = {
    children: PropTypes.node,
    filterName: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    search: PropTypes.string,
    setAdvanceFilter: PropTypes.func,
    leftNav: PropTypes.node,
    rightNav: PropTypes.node,
    inTable: PropTypes.bool,
    placeholder: PropTypes.string,
    style: PropTypes.shape({
      margin: PropTypes.any,
    }),
    searchAtKeyEnd: PropTypes.bool,
    disabled: PropTypes.bool,
    hasCompareBtn: PropTypes.bool,
    leftNavWidth: PropTypes.number,
    rightNavWidth: PropTypes.number,
    searchWidth: PropTypes.number,
  }
  static defaultProps = {
    filterName: 'search',
    isLoading: false,
    searchAtKeyEnd: false,
  }
  static getPropsToState = (props) => {
    const search = props.search || '';
    const advanceFilter = props.advanceFilter || false;
    return {
      search,
      advanceFilter,
    };
  }
  constructor(props) {
    super(props);
    const state = SearchFilter.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = SearchFilter.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  getChildName() {
    const filterNames = [];
    if (this.props.children) {
      Children.forEach(this.props.children, (child) => {
        if (child && child.props && child.props.filterName) {
          filterNames.push(child.props.filterName);
          if (child.type && child.type.name === 'DatePicker') {
            filterNames.push(child.props.filterNameTo);
            filterNames.push(child.props.filterNameFrom);
          }
        }
      });
    }
    return filterNames;
  }
  handleSearch = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (this.props.disabled) {
      return;
    }
    if (this.state.search === '' && this.props.search !== '') {
      this.props.onClose(this.props.filterName);
    } else if (this.state.search) {
      this.props.onChange(this.state.search.trim(), this.props.filterName);
    }
  }
  handleOnChange = (e) => {
    if (this.props.disabled) {
      return;
    }
    this.setState({ search: e.target.value }, () => {
      const { searchAtKeyEnd } = this.props;
      if (searchAtKeyEnd) {
        this.handleSearch();
      }
    });
  }
  handleAdvanceButtonClick = () => {
    this.setState({ advanceFilter: !this.state.advanceFilter }, () => {
      this.props.setAdvanceFilter(this.state.advanceFilter);
      if (!this.state.advanceFilter) {
        const filterNames = this.getChildName();
        this.props.onClose(...filterNames);
      }
    });
  }
  handleWidth() {
    if (this.props.leftNav && this.props.rightNav) {
      if (this.props.searchWidth) {
        return this.props.searchWidth;
      }
      return 10;
    }
    if (this.props.leftNav || this.props.rightNav) {
      return 13;
    }
    return null;
  }
  render() {
    const { t } = this.props;
    return (
      <Grid style={this.props.style}>
        <Grid.Row
          className={`app--searchcontrols ${this.state.advanceFilter ?
            'advance' : ''} ${this.props.inTable ? 'hide-side' : ''}`}
          id="searchcontrols"
          verticalAlign="top"
        >
          {this.props.leftNav &&
            <Grid.Column
              computer={this.props.leftNavWidth ? this.props.leftNavWidth : this.props.hasCompareBtn ? 2 : 3}
              tablet={this.props.leftNavWidth ? this.props.leftNavWidth : this.props.hasCompareBtn ? 1 : 3}
              className="tablet computer only"
            >
              {this.props.leftNav}
            </Grid.Column>
          }
          <Grid.Column
            tablet={this.handleWidth()}
            computer={this.handleWidth()}
          >
            <Grid centered className="searchinput">
              <Grid.Column
                mobile={this.props.children ? 13 : null}
                tablet={this.props.children ? 10 : null}
                computer={this.props.children ? 10 : null}
                className={this.props.children ? 'leftjoin' : null}
              >
                <form onSubmit={this.handleSearch}>
                  <Input
                    fluid
                    icon={
                      this.state.search ?
                        <Icon
                          color="teal"
                          link
                          name="x"
                          onClick={() => { this.props.onClose(this.props.filterName); }}
                          title={t('Clear input')}
                        />
                      : null
                    }
                    label={
                      <Button
                        className={this.props.children ? 'search-button' : 'search-button-only'}
                        icon
                        disabled={this.props.disabled || this.props.isLoading}
                        title={t('Search')}
                      >
                        <Icon name="search" />
                      </Button>
                    }
                    labelPosition="right"
                    loading={this.props.isLoading}
                    disabled={this.props.disabled || this.props.isLoading}
                    name="search"
                    onChange={this.handleOnChange}
                    placeholder={this.props.placeholder || `${t('Search')}...`}
                    value={this.state.search}
                  />
                </form>
              </Grid.Column>
              {this.props.children &&
              <Grid.Column
                textAlign="left"
                className="rightjoin"
                mobile={2}
                tablet={1}
                computer={1}
              >
                <Button
                  active={this.state.advanceFilter}
                  color={this.state.advanceFilter ? 'green' : null}
                  as="a"
                  className="advance-button"
                  icon
                  onClick={() => { this.handleAdvanceButtonClick(); }}
                  title={t('Advance Filters')}
                  disabled={this.props.disabled || this.props.isLoading}
                >
                  <Icon name="options" />
                </Button>
              </Grid.Column>
              }
            </Grid>
            {
              this.props.children &&
              <Grid centered className="filtercontrols">
                <Grid.Column mobile={16} tablet={11} computer={11}>
                  <Grid>
                    <Grid.Row>
                      <Divider horizontal className="filtertitle">{t('Filters')}</Divider>
                    </Grid.Row>
                  </Grid>
                  {this.props.children}
                </Grid.Column>
              </Grid>
            }
          </Grid.Column>
          {this.props.rightNav &&
            <Grid.Column
              tablet={this.props.rightNavWidth ? this.props.rightNavWidth : 3}
              computer={this.props.rightNavWidth ? this.props.rightNavWidth : this.props.hasCompareBtn ? 4 : 3}
              className="tablet computer only"
              textAlign="right"
            >
              {this.props.rightNav}
            </Grid.Column>
          }
        </Grid.Row>
        {/* List Controls */}
        {
          (this.props.leftNav || this.props.rightNav) &&
          <Grid.Row
            className={`app--listcontrols ${this.props.inTable ? '' : 'remove-pad-btm'}`}
            columns="equal"
            verticalAlign="middle"
            only="mobile"
          >
            {
              this.props.leftNav &&
              <Grid.Column
                width={this.props.leftNavWidth ? this.props.leftNavWidth : 3}
                className="left"
                textAlign="left"
              >
                {this.props.leftNav}
              </Grid.Column>
            }
            {
              this.props.rightNav &&
              <Grid.Column
                width={this.props.rightNavWidth ? this.props.rightNavWidth : 13}
                className="right"
                textAlign="right"
              >
                {this.props.rightNav}
              </Grid.Column>
            }
          </Grid.Row>
        }
      </Grid>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(SearchFilter);



// WEBPACK FOOTER //
// ./src/components/SearchFilter.jsx